const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

class GoogleAuthService {
  login() {
    // Redirect to backend Google OAuth endpoint
    window.location.href = `${API_BASE_URL}/api/auth/google`;
  }
}

const googleAuthService = new GoogleAuthService();
export default googleAuthService;
